import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'


import TitleCard from './components/card/TitleCard'
import BodyCard from './components/card/BodyCard'
import BtnGroupBottom from './components/buttons/BtnGroupBottom'


const app = createApp(App)

app.component('card-title', TitleCard);
app.component('card-body', BodyCard);
app.component('btn-group-bottom', BtnGroupBottom);


app.use(router)
app.mount('#app')